import pako from 'pako';

/**
 * 共通のJSON関連サービス
 */
export class JsonService {
  /**
   * オブジェクトを圧縮されたJSONに変換する
   * @param data - オブジェクト
   * @returns - zlibで圧縮されたJSONモジュール
   */
  public static convertObjectToCompressedJson(data: object) {
    return btoa(String.fromCharCode(...pako.deflate(new TextEncoder().encode(JSON.stringify(data)))));
  }
}
